const axios = require("axios");

const _baseUrl = process.env.VUE_APP_API_URL;
var _header = {
  headers: {
    "content-type": "application/json"
  }
};
export function logout(data) {
  let url = _baseUrl + "/customerApiv3/logout";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getMeta(data) {
  let url = _baseUrl + "/customerApiv3/getMetaApi";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getSlugBaseInfo(data) {
  let url = _baseUrl + "/customerApiv3/getSlugBaseInfo";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}

export function getnotifications(data) {
  let url = _baseUrl + "/customerApiv3/getnotifications";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getProfileDetails(data) {
  let url = _baseUrl + "/customerApiv3/getProfile";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}

export function sendOtp(data) {
  let url = _baseUrl + "/customerApiv3/customerOptVerification";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getUserData(data) {
  let url = _baseUrl + "/customerApiv3/verificationOtp";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}

export function registerProfile(data) {
  let url = _baseUrl + "/customerApiv3/updateProfile";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}

export function getContactUsDetails(data) {
  let url = _baseUrl + "/customerApiv3/contactus";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getCategories(data) {
  let url = _baseUrl + "/customerApiv3/getCategories";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getSubCategories(data) {
  let url = _baseUrl + "/customerApiv3/getSubCategories";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getProductList(data) {
  let url = _baseUrl + "/customerApiv3/categoryProduct";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getProductDetail(data) {
  let url = _baseUrl + "/customerApiv3/productDetail";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getProductUnitNameAndChildren(data) {
  let url = _baseUrl + "/customerApiv3/getProductUnitNameAndChieldren";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getDeliveryManInfo(data) {
  let url = _baseUrl + "/customerApiv3/recomdedItemMilkManDetails";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getdaysByArea(data) {
  let url = _baseUrl + "/customerApiv3/getdaysByArea";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getDeliveryChargeInfo(data) {
  let url = _baseUrl + "/customerApiv3/deliveryCharge";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getBalanceAndDeliveryInfo(data) {
  let url = _baseUrl + "/customerApiv3/getBalanceAndDeliveryInfo";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getDomainbaseVendorInfo(data) {
  let url = _baseUrl + "/customerApiv3/getDomainBaseVendorInfo/";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getVendorBannerListing(vendorId) {
  let url =
    _baseUrl + "/customerApiv3/vendorBannerLisitng?vendor_id=" + vendorId;

  return axios.get(url, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getVendorCurrency(vendorId) {
  let url = _baseUrl + "/customerApiv3/getVendorCurrency?vendor_id=" + vendorId;

  return axios.get(url, _header).then(res => {
    return Promise.resolve(res);
  });
}

export function getOtherVendorDetails() {
  let url = "http://juhilocal.com/juhilocalData.json";

  return axios.get(url).then(res => {
    return Promise.resolve(res);
  });
}
export function getTransactions(data) {
  let url = _baseUrl + "/customerApiv3/getTransactions";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getTransactionDetail(data) {
  let url = _baseUrl + "/customerApiv3/transactiondetails";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getBalance(data) {
  let url = _baseUrl + "/customerApiv3/getbalance";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}

export function getmasterConfiguration(data) {
  let url = _baseUrl + "/customerApiv3/masterConfiguration";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getStaticData(data) {
  let url = _baseUrl + "/customerApiv3/aboutus";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getMyOrders(data) {
  let url = _baseUrl + "/customerApiv3/getMyOrders";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function cancelOrder(data) {
  let url = _baseUrl + "/customerApiv3/cancelOrderById";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function placeOrder(data) {
  let url = _baseUrl + "/customerApiv3/saveCheckoutOrder";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}

export function getSubscriptions(data) {
  let url = _baseUrl + "/customerApiv3/activeDeActiveSubscriptionList";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function changeSubscriptionsStatus(data) {
  let url = _baseUrl + "/customerApiv3/changeSubscriptionStatus";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getDeliveryDuration(data) {
  let url = _baseUrl + "/customerApiv3/getDurations";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function getDeliveries(data) {
  let url = _baseUrl + "/customerApiv3/checkCategoryDeliverThisCustomer";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function checklatLong(data) {
  let url = _baseUrl + "/customerApiv3/checkCustomerlatLong";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
export function addAddress(data) {
  let url = _baseUrl + "/customerApiv3/addAddress";

  return axios.post(url, data, _header).then(res => {
    return Promise.resolve(res);
  });
}
